<app-confirmation-dialog [props]="props" id="del-doc-dialog">
  <div class="modal-content-container" id="del-doc-content">
    <p i18n="@@deleteDocumentConfirmationMessage" id="del-doc-p-confirm">
      ¿Confirmar la eliminación del documento {{document}}?
    </p>

    @if (!isAlert30DaysWallet) {
      <p
        style="font-size: 14px;"
        i18n="@@deleteDocumentConfirmationSubMessage"
        id="del-doc-p-submsg"
        >
      (Los documentos incluidos hace menos de 3 meses no se pueden eliminar)
    </p>
    }
  </div>
</app-confirmation-dialog>
